'use strict';
const {getRememberMeCookieField} = require('./sso.utils');
const tripdetailsStorageUtils = require('./tripdetails_storage.utils.js');
const logger = require('od-modules/utils/logger');
const trackingUtils = require('od-modules/utils/tracking.utils');

const widgets = Odigeo.autoloadWidgetsAsync({
    getUsersManager: ['users-manager', 'usersmanager'],
    getPostBookingBags: ['post-booking-bags', 'post_booking_bags'],
    getOpenMyTrips: ['openmytrips', 'my_trips'],
    getBags: ['post-booking-bags', 'post_booking_bags'],
    getSeats: ['post-booking-seats', 'post_booking_seats'],
});

const TOKEN_OK_DIFFERENT_EMAIL = 'TRC_004';
const TOKEN_KO_POPUP_ERROR = 'TRC_003';
const purchaseBagsType = 'bags';
const purchaseSeatsType = 'seats';
const BOOKING_INFO = 'bookingInfo';

const _decodeToken = function(encodedToken) {
    try {
        const decoded = atob(encodedToken);
        return JSON.parse(`{"${decodeURI(decoded).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
    } catch (error) {
        logger.error(error);
        return {};
    }
};

const _isValidToken = function(parsedToken) {
    const {email, bookingid} = parsedToken;
    return !Odigeo._.isUndefined(bookingid) && !Odigeo._.isEmpty(email) && Odigeo.Utils.isValidEmail(email);
};

const _extractTokenFromDeeplink = function(deeplinkTokenOld) {
    if (!Odigeo._.isEmpty(deeplinkTokenOld)) {
        const token = _decodeToken(deeplinkTokenOld);
        if (_isValidToken(token)) {
            return token;
        }
    }
    return {};
};

const _processOldDeeplinkToken = function(oldDeeplinkToken) {
    const token = _extractTokenFromDeeplink(oldDeeplinkToken);
    if (!Odigeo._.isEmpty(token.email)) {
        requestTrip(token);
    } else {
        handleTripError();
    }
};

const _checkTokenErrors = function(token, bookingDetailIndex) {
    const tokenEmail = token.email;
    if (!Odigeo._.isEmpty(tokenEmail) && tokenEmail !== getRememberMeCookieField('email')) {
        return TOKEN_OK_DIFFERENT_EMAIL;
    }
    if (Odigeo._.isEmpty(tokenEmail) || (bookingDetailIndex < 0)) {
        return TOKEN_KO_POPUP_ERROR;
    }
};

const processDeeplink = Odigeo._.once((deeplinkToken, deeplinkTokenOld, delay = 0) => {
    const deeplinkExecutors = [
        deeplinkToken ? () => requestEncryptedTrip(deeplinkToken) : null,
        deeplinkTokenOld ? () => _processOldDeeplinkToken(deeplinkTokenOld) : null,
    ];
    const executor = deeplinkExecutors.find((executor) => executor !== null);
    if (executor) {
        if (delay > 0) {
            setTimeout(executor, delay);
        } else {
            executor();
        }
        return true;
    }
    return false;
});

const requestMyTrips = function() {
    widgets.getUsersManager().execute('submitUserRequest', {
        'data': '',
        'action': 'getMyTrips',
    });
};

const requestTrip = function(bookingData) {
    const data = {
        queryParams: {
            email: bookingData.email,
            bookingid: bookingData.bookingid,
        },
    };
    widgets.getUsersManager().execute('submitUserRequest', {
        'data': data,
        'action': 'getTrip',
    });
};

const requestEncryptedTrip = function(deeplinkToken) {
    const data = {
        queryParams: {
            td: deeplinkToken,
        },
    };
    widgets.getUsersManager().execute('submitUserRequest', {'data': data, 'action': 'getEncryptedTrip'});
};

const handleTripError = function() {
    tripdetailsStorageUtils.removeInSessionWithExpirationTime(BOOKING_INFO);
    Odigeo.Router.navigate('mytripslogin');
};

const saveDeeplinksInSession = function(deeplinkToken, deeplinkTokenOld) {
    if (!Odigeo._.isEmpty(deeplinkToken)) {
        Odigeo.Session.set('td', deeplinkToken);
    } else if (!Odigeo._.isEmpty(deeplinkTokenOld)) {
        Odigeo.Session.set('tdo', deeplinkTokenOld);
    }
};

const findBooking = function(data, id) {
    const index = Odigeo._.findIndex(data, function(booking) {
        return booking.bookingBasicInfo.id === id;
    });
    return index;
};

const retrieveBookingInfoFromToken = function(tdid, tdo, data) {
    let bookingID;
    let error;
    let bookingDetailIndex;

    if (!Odigeo._.isEmpty(tdid)) {
        bookingID = Odigeo._.parseInt(tdid, 10);
    } else if (!Odigeo._.isEmpty(tdo)) {
        const token = _extractTokenFromDeeplink(tdo);
        bookingID = Odigeo._.parseInt(token.bookingid, 10);
        bookingDetailIndex = findBooking(data.userDTO.bookingDetail, bookingID);
        error = _checkTokenErrors(token, bookingDetailIndex);
    }
    return {
        bookingID: (!error) ? bookingID : null,
        bookingDetailIndex: bookingDetailIndex,
        error: error,
    };
};

const navigateToBooking = function(bookingInfo, data) {
    const index = bookingInfo.bookingDetailsIndex || findBooking(data.userDTO.bookingDetail, bookingInfo.bookingID);
    if (index < 0) {
        Odigeo.Utils.goToApplicationHome();
    } else {
        tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, {
            ...data.userDTO.bookingDetail[index],
            forceReload: Odigeo.AB.isBookingImportantMessage,
        });
        Odigeo.Router.navigate('tripdetails');
    }
};

const showPopUpPurchaseOk = function(typePurchase) {
    if (typePurchase === purchaseBagsType) {
        widgets.getBags().execute('showSuccess');
    } else if (typePurchase === purchaseSeatsType) {
        widgets.getSeats().execute('showSuccess');
    }
};

const checkinMfTracking = function(booking, from, product = null) {
    const TRACKING_LABEL_PARTS = {
        myTripsList: 'click_checkin_pag:triphome',
        tripDetailsCheckinBtn: 'click_checkin_pag:tripdetails',
        tripDetailsStatusCheckinBtn: 'reclick_checkin_pag:tripdetails',
        checkinMfOnLoadOK: 'onload-ok_checkin_pag:tripdetails',
        checkinMfOnLoadOKSuccess: 'onload-ok-success_checkin_pag:tripdetails',
        checkinMfOnLoadOKFailed: 'onload-ok-failed_checkin_pag:tripdetails',
        checkinMfOnLoadOKCreate: 'onload-ok-create_checkin_pag:tripdetails',
        checkinMfOnLoadOKMoreInfo: 'onload-ok-moreinfo_checkin_pag:tripdetails',
        checkinMfOnLoadNoConf: 'onload-noconf_checkin_pag:tripdetails',
        checkinMfOnLoadScope: 'onload-scope_checkin_pag:tripdetails',
        checkinMfOnLoadBlack: 'onload-black_checkin_pag:tripdetails',
        checkinMfOnLoadCsna: 'onload-csna_checkin_pag:tripdetails',
        checkinMfOnLoadSeatNa: 'onload-seatna_checkin_pag:tripdetails',
        checkinMfOnLoadNotSb: 'onload-notsb_checkin_pag:tripdetails',
        checkinMfOnLoadDisabled: 'onload-diskey_checkin_pag:tripdetails',
        clickDownloadAppNoConf: 'click-noconf_checkin_pag:tripdetails',
        clickDownloadAppScope: 'click-scope_checkin_pag:tripdetails',
        clickDownloadAppBlack: 'click-black_checkin_pag:tripdetails',
        clickDownloadAppCsna: 'click-csna_checkin_pag:tripdetails',
        clickDownloadAppSeatNa: 'click-seatna_checkin_pag:tripdetails',
        clickDownloadAppNotSb: 'click-notsb_checkin_pag:tripdetails',
        clickDownloadAppDisabled: 'click-diskey_checkin_pag:tripdetails',
        closeBtn0: 'close_checkin_pag:checkhome',
        closeBtn1: `close_checkin_pag:checkseatsel-${product}`,
        closeBtn2: 'close_checkin_pag:checkboarding',
        closeCheckIn: 'close_checkin_pag:checkboarding',
        closeCheckInWithResult: `close_checkin_pag:checkboarding-${product}`,
        continueBtn0: `next_checkin_pag:checkhome-${product}`,
        continueBtn1: `next_checkin_pag:checkseatsel-${product}`,
        continueBtn2: `next_checkin_pag:checkseatconf-${product}`,
        continueBtnCheckIn: `next_checkin_pag:checkboarding-${product}`,
        checkinBtn: 'next_checkin_pag:checkboarding',
        checkinSeatOfferSelection: `seat-${product}_checkin_pag:checkseatsel-seatyes`,
        checkinSeatMapClear: `seat-${product}_pag:checkseatadd`,
        checkinOnChangeSeatSelection: `seat-${product}_pag:checkseatpay`,
        checkinOnPaymentSuccess: `seat-${product}_pag:checkseatconf`,
        checkinOnPaymentError: `seat-${product}_pag:checkseatconf`,
        checkinOnSeatSelConfirmation: `seat-${product}_pag:checkseatadd`,
        checkinInsurancesHaveInsurance: `ins-${product}_checkin_pag:checkins`,
        checkinInsurancesOnClickButton: `next-${product}_checkin_pag:checkins`,
        checkinInsurancesProductAdded: `ins-${product}_checkin_pag:checkinsadd`,
        checkinInsurancesDropdownView: `ins-${product}_checkin_pag:checkinsadd`,
        checkinInsurancesInsuranceAdded: `next-${product}_checkin_pag:checkinsadd`,
        checkinOnTermsLink: `terms_checkin_pag:checkinsadd`,
        checkinOnInsuranceSummaryLink: `summary_checkin_pag:checkinsadd`,
        checkinOnChangeInsuranceSelection: `ins-change_checkin_pag:checkpay`,
        checkinOnPurchaseButton: `pay-${product}_checkin_pag:checkpay`,
        trackCheckinError: `pay-${product}_checkin_pag:checkpay`,
        trackCloseCmfPage: `close_checkin_pag:${product}`,
    };
    const TYPES = {
        ONE_WAY: 'OW',
        ROUND_TRIP: 'RT',
        MULTI_SEGMENT: 'MD',
    };
    const META = Odigeo.SessionScope.marketingPortalIsMeta ? 1 : 0;
    const TYPE = TYPES[booking.itineraryBookings.bookingItinerary.tripType];
    const PROV = (booking.checkinConditions.gds) ? 'gds' : 'NA';
    const PAX = booking.travellers.length;
    const SCEN = booking.accommodationBooking ? 'DP' : 'FL';
    const TOTLEG = booking.itineraryBookings.itinerarySegments.length;

    return `${TRACKING_LABEL_PARTS[from]}_trip:meta:${META}_type:${TYPE}_prov:${PROV}_pax:${PAX}_scen:${SCEN}_totleg:${TOTLEG}_leg:${TOTLEG}`;
};

const notValidBookingInfoHandler = function(bookingInfo) {
    if (bookingInfo) {
        const data = {
            email: bookingInfo.buyer.mail,
            bookingid: bookingInfo.bookingBasicInfo.id,
        };
        if (!bookingInfo.forceReload) {
            tripdetailsStorageUtils.removeBookingInfoWithPersistBookingIdAndEmail(bookingInfo);
        }
        requestTrip(data);
    }
};

const deepLinkTracking = function(params, result) {
    const url = new URL(window.location.href);
    const decodeUrlSearchParams = Odigeo.Utils.decodeParams(url.search.slice(1));
    const decodedUrlParams = Odigeo.Utils.decodeParams(params);
    const urlParams = Object.assign(decodeUrlSearchParams, decodedUrlParams);

    const utmParams = Object.keys(urlParams).filter((key) => key.includes('utm'));
    const referralParams = Object.keys(urlParams).filter((key) => key.includes('referral'));
    const otherParams = Object.keys(urlParams).filter((key) => !key.includes('referral') && !key.includes('utm') && !key.includes('td'));
    const utmParamsPartial = formatTrackingParams(utmParams, urlParams) || 'na';
    const referralPartial = urlParams[referralParams] || 'na';
    const otherParamsPartial = formatTrackingParams(otherParams, urlParams) || 'na';
    const resultPartial = result ? '1' : '0';
    const deepLinkLabel = `deeplink_onload_success:${resultPartial}_utm:${utmParamsPartial}_referral:${referralPartial}_other:${otherParamsPartial}`;
    trackingUtils.trackEventWithCategory('tripdetails', 'deeplink', deepLinkLabel);
};

const formatTrackingParams = function(paramsList, params) {
    return paramsList.reduce((acc, el) => `${acc}_${el.replace(/(_)/g, '-')}=${params[el].replace(/(_)/g, '-')}`, '').slice(1);
};

const shouldExecuteRefresh = function(bookingProductStatus, bookingId, deeplinkOrigin, refreshTime) {
    const hasRefreshedFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('hasRefreshedFromConfirmation'));
    if ( ['PARTIALLY_CONFIRMED', 'PENDING'].includes(bookingProductStatus)
    && Odigeo.History.getPageNameFromFragment() === 'tripdetails'
    && hasRefreshedFromConfirmation?.bookingId !== bookingId) {
        return setTimeout(()=>{
            tripdetailsStorageUtils.refreshGeneralStatusRefresh(deeplinkOrigin);
        }, refreshTime);
    }
};

const pauseAutoRefresh = function(autoRefreshTimeout) {
    if (autoRefreshTimeout) {
        clearTimeout(autoRefreshTimeout);
        tripdetailsStorageUtils.removeRefreshedFromConfirmation();
    }
};

let bagsAndSeatsLoaded = {
    bags: {
        loaded: false,
        showLink: false,
    },
    seats: {
        loaded: false,
        showLink: false,
    },
};
const isLoadedBagsAndSeats = () => bagsAndSeatsLoaded.bags.loaded && bagsAndSeatsLoaded.seats.loaded;
const getBagsAndSeatsLoaded = () => bagsAndSeatsLoaded;
const setBagsAndSeatsLoaded = ({product, showLink}) => {
    bagsAndSeatsLoaded[product].showLink = showLink;
    bagsAndSeatsLoaded[product].loaded = true;
};

module.exports = {
    processDeeplink,
    handleTripError,
    requestMyTrips,
    requestTrip,
    requestEncryptedTrip,
    findBooking,
    retrieveBookingInfoFromToken,
    navigateToBooking,
    saveDeeplinksInSession,
    showPopUpPurchaseOk,
    checkinMfTracking,
    notValidBookingInfoHandler,
    deepLinkTracking,
    shouldExecuteRefresh,
    pauseAutoRefresh,
    getBagsAndSeatsLoaded,
    setBagsAndSeatsLoaded,
    isLoadedBagsAndSeats,
};
